import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'notificacao-prestacao-contas',
  templateUrl: './notificacao-prestacao-contas.component.html'
})
export class NotificacaoPrestacaoContasComponent implements OnInit {

  @Input() showAlert : boolean = false;

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/Componentes/notificacao-prestacao-contas/notificacao-prestacao-contas.component.ts